<form>
    <table style="margin-top:20px" aria-describedby="delegTable">
        <tr>
            <td>
                <label appendTo="body" class="text">InfRef:</label>
            </td>
            <td>
                <label appendTo="body" class="text">{{delegation1.routingInfRef.infRefName}}</label>
            </td>
            <td>
                <label *ngIf="delegation1.routingInfRef.changedBy" style="position: relative; right: 200px"
                    appendTo="body" class="text">Ændret:</label>
            </td>
            <td *ngIf="delegation1.routingInfRef.changedBy">
                <label style="position: relative; right: 150px" appendTo="body" class="text">
                    {{delegation1.routingInfRef.changedDate}} af {{delegation1.routingInfRef.changedBy}},
                    {{delegation1.user.name}}
                </label>
            </td>
        </tr>
        <tr>
            <td style="width: 20%;">
                <label appendTo="body" class="text">Type:</label>
            </td>
            <td colspan="3">
                <label appendTo="body" class="text">{{ getServiceTypeText(delegation1.routingInfRef.serviceType)}}</label>
            </td>
        </tr>
        <tr>
            <td>
                <label appendTo="body" class="text">Organistaion:</label>
            </td>
            <td colspan="3">
                <label appendTo="body" class="text">
                    {{delegation1.user.name }} {{delegation1.user.cvr }}
                </label>
            </td>
        </tr>
        <!-- chip row -->
        <tr>
            <td>
                <label appendTo="body" class="text">Delegerede:</label>
            </td>
            <td style="width: 100%" colspan="3">
                <mat-chip-row *ngFor="let fruit of delegation1.delegeredeUser" (removed)="remove(fruit)"
                    [aria-description]="'press enter to edit ' + fruit.name">
                    {{fruit.name}} (CVR{{fruit.cvr}})
                    <button [disabled]="!delegation1.canEdit" matChipRemove [attr.aria-label]="'remove ' + fruit.name">
                        <i class="pi pi-times" style="color: #ffffff; font-weight: bolder;"></i>
                    </button>
                </mat-chip-row>
                <br><br>
            </td>
        </tr>
        <tr *ngIf="delegation1.canEdit">
            <td> </td>
            <td colspan="3">
                <div style="width: 80%;">
                <p-table #dt id="tb_id" (onRowUnselect)="onRowSelect($event)" (onRowSelect)="onRowSelect($event)" dataKey="x"
                    [rows]="rowsPerPage" [paginator]="false" [rowHover]="true" [value]="products" dataKey="id" selectionMode="single"
                    [showFirstLastIcon]="false" [customSort]="true" (sortFunction)="customSort($event)"
              >
                    <ng-template pTemplate="header">
                        <tr>
                            <th hidden="true" id="userHead">id</th>
                            <th style="width: 80%" pSortableColumn="name" id="nameHead">
                                Navn<p-sortIcon field="name"></p-sortIcon>
                            </th>
                            <th style="width: 20%" pSortableColumn="cvr" id="cvrHead">
                                CVR<p-sortIcon field="cvr"></p-sortIcon>
                            </th>
                        </tr>
                        <tr>
                            <th id="nameFilterHead">
                                <input style="width: 100%" pInputText type="text" #textInput1
                                    (input)="inputChange(textInput1.value, 'name')"
                                    [value]="$any(dt.filters['name'])?.value"
                                    class="p-column-filter" />
                            </th>
                            <th id="cvrFilterHead">
                                <input style="width: 100%" pInputText type="text" #textInput3
                                    (input)="inputChange(textInput3.value, 'cvr')"
                                    [value]="$any(dt.filters['cvr'])?.value"
                                    class="p-column-filter" />
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-prod>
                        <tr [pSelectableRow]="prod">
                            <td hidden="true">{{ prod.mapping_id }}</td>
                            <td>{{ prod.name }}</td>
                            <td>{{ prod.cvr }}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <ngb-pagination #paginationEdit *ngIf="showPagination "
                    aria-label="pagination" class="d-flex justify-content-center" [collectionSize]="totalRecords" [(page)]="currentPage"
                    [pageSize]="rowsPerPage" [maxSize]="5" [rotate]="true" size="lg" [boundaryLinks]="false"
                    (pageChange)="onPageChange($event)">
                </ngb-pagination>

                <br />
                </div>
            </td>
        </tr>
    </table>
</form>
<div>
    <span>
        <button [disabled]="!delegation1.canEdit" pButton class="add-button" label="Gem" (click)="submit()"></button>
    </span>
    <span>
        <button pButton label="Annuller" class="add-button secondary" (click)="onCancel()"></button>
    </span>
</div>